import { Outlet, useNavigate, useLocation } from 'react-router-dom';

import { useState, useEffect } from 'react'
import { LeftNav } from '@/components/layout/LeftNav';

export const HomePageV2 = () => {
	const navigate = useNavigate();
	const location = useLocation();

	// Helper function to get section from pathname
	const getSectionFromPath = (pathname: string) => {
		// Remove leading slash and get the first segment
		const path = pathname.replace('/', '');
		// If empty path, it's the overview section
		return path === '' ? 'overview' : path;
	};

	// Initialize selectedSection based on current URL
	const [selectedSection, setSelectedSection] = useState(() => getSectionFromPath(location.pathname));

	// Keep selectedSection in sync with URL changes
	useEffect(() => {
		const section = getSectionFromPath(location.pathname);
		setSelectedSection(section);
	}, [location.pathname]);

	const handleNavSelect = (id: string) => {
		setSelectedSection(id);

		// special consideration for 'overview' which should resolve to '/'
		navigate(id === "overview" ? '/' : `/${id}`);
	};

	return (
		<div className='flex flex-row overflow-hidden w-full h-full'>
			<LeftNav selectedId={selectedSection} onSelect={handleNavSelect} className='hidden lg:block w-60 bg-[#C0E6FF]/10 backdrop-blur-md border border-t-0' />
			<Outlet />
		</div>
	)
}